var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChartTrendingUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 36"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-figma-bg-blur-radius": 24
}, /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  fill: "#00A68C",
  fillOpacity: 0.1,
  rx: 18
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5DD1BF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M24.667 14.667 18.833 20.5 15.5 17.166l-5 5"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5DD1BF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M20.714 13.893h4.464a.25.25 0 0 1 .25.25v4.464"
}))));
export default SvgChartTrendingUp;